import styled from '@emotion/styled';

import { capitalizeWords } from '../../../utils/utils';

interface TableImageWithLabelProps {
  data?: Record<string, any>;
  dataKey?: string;
  imageUrlKey?: string;
  className?: string;
}

const TableImageWithLabel: React.FC<TableImageWithLabelProps> = ({
  data,
  dataKey,
  imageUrlKey,
  className,
}) => {
  const label = data && data[dataKey ?? ''];
  const imageUrl =
    data && data[imageUrlKey ?? '/static/img/profilePlaceholder2.png'];
  const capitalizedLabel = label ? capitalizeWords(String(label)) : 'N/A';

  return (
    <Container className={className}>
      <Img
        src={imageUrl || '/static/img/profilePlaceholder2.png'}
        alt={capitalizedLabel}
      />
      <Text>{capitalizedLabel}</Text>
    </Container>
  );
};

export default TableImageWithLabel;

const Container = styled.div`
  /* word-break: break-word; */
  width: 100%;
  display: grid;
  grid-template-columns: 36px auto;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.neutralGray};
  font-size: 13px;
`;

const Img = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: cover;
`;

const Text = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.neutralGray};
  font-size: 13px;
`;
